export const meta = $state({
    csrfToken: '',
});
